import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useBillingAddressFormStyles = makeStyles({
    inquiryContactInfo: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridTemplateRows: 'repeat(5, 1fr)',
        columnGap: tokens.spacingHorizontalXXL,
        rowGap: tokens.spacingVerticalM,
        marginTop: tokens.spacingVerticalM,
        marginBottom: tokens.spacingVerticalM,
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            flexDirection: 'column'
        },
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    firstNameContainer: { ...shorthands.gridArea('1', '1', '2', '4') },
    lastNameContainer: { ...shorthands.gridArea('1', '4', '2', '7') },
    address1Container: { ...shorthands.gridArea('2', '1', '3', '7') },
    address2Container: { ...shorthands.gridArea('3', '1', '4', '7') },
    cityContainer: { ...shorthands.gridArea('4', '1', '5', '3') },
    stateContainer: { ...shorthands.gridArea('4', '3', '5', '5'), minWidth: 'unset' },
    zipcodeContainer: { ...shorthands.gridArea('4', '5', '5', '7') },
    dobContainer: { ...shorthands.gridArea('5', '1', '5', '3') },
    billingAddress: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        '@media screen and (max-width: 550px)': {
            flexDirection: 'column'
        }
    },
    autopayEbill: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        '@media screen and (max-width: 480px)': {
            flexDirection: 'column'
        }
    },
    checkboxWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    lineBreak: {
        ...shorthands.margin(tokens.spacingVerticalL, '0')
    }
});

export default useBillingAddressFormStyles;
